import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { components } from "react-select";
import { toJS } from "mobx";
import lang from "../../lang";
import Domen from "../../stores/Domen";

import GlobalState, {
  setifblock,
  changepopupdeleteClause,
} from "../../stores/GlobalState";

import { getColumnInfo } from "./module/GetColumnInfo";
import { EditAttributeName } from "./module/EditAttributeName";

import CreateSegmentation from "./page/CreateSegmentationforModel";

/**
 * Самодостатній блок CreateSegmentation:
 * - тягне весь state/методи з Sidebar, які потрібні CreateSegmentation
 * - ти підключаєш його де завгодно: <CreateSegmentationBlock />
 */
const CreateSegmentationBlock = observer(({ initialLang, onEditAttribute, segmentName, modelId, datasetId, initialSegmentConditions, additionOff, readOnly, }) => {
  // ==== lang ====
  const [langmenu] = useState(localStorage.getItem("lang_site") || "en");
  const [langv] = useState(
    initialLang || (langmenu === "de" ? lang.de : lang.en)
  );
  const didInitColumnsRef = useRef(false);
  const lastFetchedDatasetRef = useRef(null);
  // ==== state (з Sidebar) ====
  const [errorNameAttr, setErrorNameAttr] = useState(false);
  const [inputNameColumn, setInputNameColumn] = useState("");
  const [optionscsw, setOptionscsw] = useState([]);
  const [activeDataset, setActiveDataset] = useState(datasetId);
  const [updateselect, setUpdateselect] = useState(false);

  const [activedataset, setActivedataset] = useState([]);
  const [masscheca, setMasscheca] = useState([]);
  const [optionif, setOptionif] = useState("");
  const [datasetType, setDatasetType] = useState("");
  const [elseval, setElseval] = useState("");

  const [countword, setCountword] = useState(0);
  const [countwordLast, setCountwordLast] = useState(0);
  const [textinselect, setTextinselect] = useState("0");

  const blockRef = useRef(null);
  const blockRef2 = useRef(null);
  const [widthselect, setSelect] = useState(0);
  const [widthselect2, setSelect2] = useState(0);

  // для EditAttributeNameAndParam (як у Sidebar)
  const [inputt4, setInputt4] = useState("");

  // ==== константи (як у Sidebar) ====
  const optionoper = [
    { value: ">=", label: ">=" },
    { value: "=", label: "=" },
    { value: "<=", label: "<=" },
    { value: "<", label: "<" },
    { value: ">", label: ">" },
  ];

  const optionopercat = [
    { value: "=", label: "=" },
    { value: "≠", label: "≠" },
  ];

  // ==== styles (з Sidebar) ====
  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "rgba(45, 50, 57, 1)",
      display: "flex",
      flexWrap: "nowrap",
      width: "100%",
      height: "38px",
      color: "rgba(245, 197, 56, 1)",
      border: "0px solid rgba(244, 245, 247, 1)",
      boxShadow: "none",
      fontSize: 16,
    }),
    input: (provided) => ({
        ...provided,
        color: "rgba(245, 197, 56, 1)",
    }),
    menu: (provided) => ({
      ...provided,
      width: "100%",
      border: "1px solid rgba(229, 229, 234, 1)",
      marginTop: "-9px",
      BorderTop: "0px",
      boxShadow: "none",
      cursor: "pointer",
      color: "rgba(2, 2, 3, 1)",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      paddingLeft: 0,
      color: state.isSelected ? "rgba(235, 115, 27, 1)" : "rgba(2, 2, 3, 1)",
      backgroundColor: "rgba(255, 255, 255, 0)",
      "&:hover": { color: "rgba(235, 115, 27, 1)" },
      "&:focus": { backgroundColor: "rgba(45, 50, 57, 1)" },
      "&:active": { backgroundColor: "rgba(45, 50, 57, 1))" },
    }),
  };

  const customStylesoper = {
    control: (provided) => ({
      ...provided,
      background: "rgba(45, 50, 57, 1)",
      display: "flex",
      flexWrap: "nowrap",
      width: "95%",
      height: "38px",
      color: "rgba(245, 197, 56, 1)",
      border: "0px solid rgba(244, 245, 247, 1)",
      boxShadow: "none",
      fontSize: 16,
    }),
    input: (provided) => ({
        ...provided,
        color: "rgba(245, 197, 56, 1)",
    }),
    menu: (provided) => ({
      ...provided,
      width: "95%",
      border: "1px solid rgba(229, 229, 234, 1)",
      marginTop: "-9px",
      BorderTop: "0px",
      boxShadow: "none",
      cursor: "pointer",
      color: "rgba(2, 2, 3, 1)",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      paddingLeft: 0,
      color: state.isSelected ? "rgba(235, 115, 27, 1)" : "rgba(2, 2, 3, 1)",
      backgroundColor: "rgba(255, 255, 255, 0)",
      "&:hover": { color: "rgba(235, 115, 27, 1)" },
      "&:focus": { backgroundColor: "rgba(45, 50, 57, 1)" },
      "&:active": { backgroundColor: "rgba(45, 50, 57, 1))" },
    }),
    
  };

  const DropdownIndicator = (props) =>
    components.DropdownIndicator ? (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="6.84706" cy="9.96229" r="1.53846" fill="#020203" />
            <circle
              cx="6.84706"
              cy="9.96229"
              r="1.53846"
              fill="black"
              fillOpacity="0.2"
            />
            <circle
              cx="6.84706"
              cy="9.96229"
              r="1.53846"
              fill="black"
              fillOpacity="0.2"
            />
            <path
              d="M0.691406 7.65385L7.03173 1.5L12.9991 7.65385"
              stroke="#020203"
              strokeLinecap="round"
            />
            <path
              d="M0.691406 7.65385L7.03173 1.5L12.9991 7.65385"
              stroke="black"
              strokeOpacity="0.2"
              strokeLinecap="round"
            />
            <path
              d="M0.691406 7.65385L7.03173 1.5L12.9991 7.65385"
              stroke="black"
              strokeOpacity="0.2"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          <svg
            width="14"
            height="11"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="1.53846"
              cy="1.53846"
              r="1.53846"
              transform="matrix(1 0 0 -1 5.80859 3.07617)"
              fill="#020203"
            />
            <circle
              cx="1.53846"
              cy="1.53846"
              r="1.53846"
              transform="matrix(1 0 0 -1 5.80859 3.07617)"
              fill="black"
              fillOpacity="0.2"
            />
            <circle
              cx="1.53846"
              cy="1.53846"
              r="1.53846"
              transform="matrix(1 0 0 -1 5.80859 3.07617)"
              fill="black"
              fillOpacity="0.2"
            />
            <path
              d="M1.19141 3.84615L7.53173 10L13.4991 3.84615"
              stroke="#020203"
              strokeLinecap="round"
            />
            <path
              d="M1.19141 3.84615L7.53173 10L13.4991 3.84615"
              stroke="black"
              strokeOpacity="0.2"
              strokeLinecap="round"
            />
            <path
              d="M1.19141 3.84615L7.53173 10L13.4991 3.84615"
              stroke="black"
              strokeOpacity="0.2"
              strokeLinecap="round"
            />
          </svg>
        )}
      </components.DropdownIndicator>
    ) : null;

  // ==== build dataset options (щоб компонент заводився без Sidebar) ====
  useEffect(() => {
    // беремо зі стора; якщо він уже завантажений в іншій частині апки, цього достатньо
    const iter = [];
    GlobalState.dataset?.forEach((n) => iter.push({ value: n.id, label: n.name }));
    setOptionscsw(iter);
  }, [GlobalState.dataset?.length]);

  // ==== optionif з masscheca ====
  useEffect(() => {
    let t = [];
    masscheca?.forEach((n) => {
      t = [...t, { id: n.id, value: n.title, label: n.title }];
    });
    setOptionif(t);
  }, [masscheca]);

  // ==== ResizeObserver + updateWord (як у Sidebar) ====
  useEffect(() => {
    const el = blockRef.current;
    const observer = new ResizeObserver(() => {
      if (el) setSelect(el.offsetWidth);
    });

    if (el) observer.observe(el);
    return () => {
      if (el) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const el = blockRef.current;
    const observer = new ResizeObserver(() => {
      if (el) setSelect(el.offsetWidth);
      updateWord();
    });

    if (el) observer.observe(el);
    return () => {
      if (el) observer.disconnect();
    };
  }, [GlobalState.ifblock]);

  useEffect(() => {
    if (!blockRef2.current) return;
    const el = blockRef2.current;
    const observer = new ResizeObserver(() => {
      setSelect2(el.offsetWidth);
      updateWord();
    });
    observer.observe(el);

    return () => observer.disconnect();
   
  }, [blockRef2.current, GlobalState.ifblock]);

  const updateWord = () => {
    let sim = 0;
    let word = 0;
    let wordlast = 0;
    let w = 0;
    const w2 = widthselect2 - 170;

    if (widthselect !== 0) w = widthselect - 170;
    if (widthselect2 !== 0) w = widthselect2 - 170;

    let t = 0;
    let hasAnyChecked = false;
    GlobalState.ifblock?.forEach((n) => {
      n.list?.forEach((g) => {
        if (g.activColumn !== "") {
          g.operator?.forEach((v) => {
            if (g.type === "categorical") {
              if (Array.isArray(v.value)) {
                v.value?.forEach((nn) => {
                  if (nn?.check === true) hasAnyChecked = true;
                  if (nn.name) {
                    sim += nn.name?.length;
                    if (nn.check === true) wordlast = wordlast * 1 + 1;
                    t = sim * 6 + wordlast * 25;
                    if (t < w) word = word + 1;
                  } else {
                    sim += nn?.length;
                    wordlast = wordlast * 1 + 1;
                    t = sim * 7 + wordlast * 25;
                    if (t < w2) word = word + 1;
                  }
                });
              }
            }
          });
        }
      });
    });

    wordlast = wordlast * 1 - word;
    setCountword(word);
    setCountwordLast(wordlast);
    setTextinselect(hasAnyChecked ? 1 : 0);
  };

  // ==== методи (з Sidebar) ====
  const setInputNameColumn0 = (a) => {
    setInputNameColumn(a);
    let c = 0;
    GlobalState.activeportraits?.data?.forEach((n) => {
      if (n.name === a) c = 1;
    });
    setErrorNameAttr(c === 1);
  };

  const setOptionmetricsforcreate = (a) => {
    if (!a) return;
    if (lastFetchedDatasetRef.current === a) return;
    lastFetchedDatasetRef.current = a;
    setUpdateselect(true);
    const t = [
      {
        then: "",
        list: [
          {
            title: "if",
            activColumn: "",
            type: "",
            operator: [{ operator: "", value: "", select: false }],
          },
        ],
      },
    ];
    setifblock(t);
    setActiveDataset(a);
    getColumnInfo(a, setMasscheca, setActivedataset, setUpdateselect);
    setElseval("");
  };

  const setOptionmetrics1 = (a, vid, vid2) => {
      let t = [];
      let l = [];
      let op = [];
      const atrim = GlobalState.ifblock;

      setifblock([]);

      atrim.map((n, id) => {
          if (id == vid) {
              l = [];

              n.list?.map((y, id2) => {
                  op = [];

                  if (id2 == vid2) {
                      activedataset.map((u) => {
                          if (a == u.title) {
                              y.operator?.map((v) => {
                                  op = [
                                      ...op,
                                      {
                                          operator: "",
                                          value:
                                              u.type === "categorical" || u.type === "datetime"
                                                  ? u.categories
                                                  : "",
                                          select: false
                                      }
                                  ];
                              });

                              l = [
                                  ...l,
                                  {
                                      title: y.title,
                                      activColumn: a,
                                      type: u.type,
                                      operator: op
                                  }
                              ];
                          }
                      });
                  } else {
                      l = [
                          ...l,
                          {
                              title: y.title,
                              activColumn: y.activColumn,
                              type: y.type,
                              operator: y.operator
                          }
                      ];
                  }
              });

              t = [...t, { then: n.then, list: l }];
          } else {
              t = [...t, { then: n.then, list: n.list }];
          }
      });

      setifblock(t);
  };

  const setOperator = (a, vid, vid2, f) => {
    let t = [];
    let l = [];
    let op = [];

    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        l = [];
        n.list?.forEach((y, id2) => {
          if (id2 === vid2) {
            op = [];
            y.operator?.forEach((v, g) => {
              if (g === f) op = [...op, { operator: a, value: v.value, select: v.select }];
              else op = [...op, { operator: v.operator, value: v.value, select: v.select }];
            });
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: op }];
          } else {
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator }];
          }
        });
        t = [...t, { then: n.then, list: l }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });

    setifblock(t);
  };

  const changeThen = (a, vid) => {
    let t = [];
    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) t = [...t, { then: a, list: n.list }];
      else t = [...t, { then: n.then, list: n.list }];
    });
    setifblock(t);
  };

  const addNewLine = () => {
    const t = [
      ...(GlobalState.ifblock || []),
      { then: "", list: [{ title: "if", activColumn: "", operator: [{ operator: "", value: "", select: false }] }] },
    ];
    setifblock(t);
  };

  const addNewLinesub = (vid) => {
    let t = [];
    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        const l = [...(n.list || []), { title: "and", activColumn: "", operator: [{ operator: "", value: "", select: false }] }];
        t = [...t, { then: n.then, list: l }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });
    setifblock(t);
  };

  const addNewLinesubsub2 = (vid, vid2) => {
    let t = [];
    let l0 = [];
    let op = [];

    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        l0 = [];
        op = [];
        n.list?.forEach((y, id2) => {
          if (id2 === vid2) {
            if (y.type === "categorical") {
              activedataset?.forEach((u) => {
                if (y.activColumn === u.title) {
                  op = [...y.operator, { operator: "", value: u.categories, select: false }];
                }
              });
            } else {
              op = [...y.operator, { operator: "", value: "", select: false }];
            }
            l0 = [...l0, { title: y.title, type: y.type, activColumn: y.activColumn, operator: op }];
          } else {
            l0 = [...l0, y];
          }
        });
        t = [...t, { then: n.then, list: l0 }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });

    setifblock(t);
  };
  
  const setValueselect = (a, vid, vid2, f) => {
    let t = [];
    let l = [];
    let op = [];

    a = String(a).replace(/[^0-9.]/g, "");
    // const parts = a.split(".");
    // if (parts.length > 2) a = parts[0] + "." + parts[1];

    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        l = [];
        n.list?.forEach((y, id2) => {
          if (id2 === vid2) {
            op = [];
            y.operator?.forEach((v, g) => {
              if (g === f) op = [...op, { operator: v.operator, value: a, select: v.select }];
              else op = [...op, { operator: v.operator, value: v.value, select: v.select }];
            });
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: op }];
          } else {
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator }];
          }
        });
        t = [...t, { then: n.then, list: l }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });

    setifblock(t);
  };

  const checkmultiselectmulty = (a, vid, vid2, tg, f) => {
    let t = [];
    let l = [];
    let l2 = [];
    let op = [];

    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        l = [];
        n.list?.forEach((y, id2) => {
          if (id2 === vid2) {
            op = [];
            y.operator?.forEach((v, g) => {
              l2 = [];
              if (Array.isArray(v.value)) {
                v.value?.forEach((gh, oi) => {
                  if (oi === a) l2 = [...l2, { check: !gh.check, name: gh.name }];
                  else l2 = [...l2, { check: gh.check, name: gh.name }];
                });
              }

              if (g === f) op = [...op, { operator: v.operator, value: l2, select: v.select }];
              else op = [...op, { operator: v.operator, value: v.value, select: v.select }];
            });

            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: op }];
          } else {
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator }];
          }
        });

        t = [...t, { then: n.then, list: l }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });

    setifblock(t);
    setTextinselect(1);
  };

  const setOpenselectful = (vid, vid2, f) => {
    let t = [];
    let l = [];
    let op = [];

    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        l = [];
        n.list?.forEach((y, id2) => {
          if (id2 === vid2) {
            op = [];
            y.operator?.forEach((v, g) => {
              if (g === f) op = [...op, { operator: v.operator, value: v.value, select: true }];
              else op = [...op, { operator: v.operator, value: v.value, select: v.select }];
            });
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: op }];
          } else {
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator }];
          }
        });

        t = [...t, { then: n.then, list: l }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });

    setifblock(t);
  };

  const setOpenselectful2 = (vid, vid2, f) => {
    let t = [];
    let l = [];
    let op = [];

    GlobalState.ifblock?.forEach((n, id) => {
      if (id === vid) {
        l = [];
        n.list?.forEach((y, id2) => {
          if (id2 === vid2) {
            op = [];
            y.operator?.forEach((v, g) => {
              if (g === f) op = [...op, { operator: v.operator, value: v.value, select: false }];
              else op = [...op, { operator: v.operator, value: v.value, select: v.select }];
            });
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: op }];
          } else {
            l = [...l, { title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator }];
          }
        });

        t = [...t, { then: n.then, list: l }];
      } else {
        t = [...t, { then: n.then, list: n.list }];
      }
    });

    setifblock(t);
  };

  // ==== delete clause (повністю з Sidebar) ====
  const changepopupdeleteClauseInside = async (id, activeDataset, im, el, vid, type, cr, f) => {
    changepopupdeleteClause(id, activeDataset, im, el, vid, type, cr, f);

    if (GlobalState.clauseType === 1) {
      const atrim = GlobalState.ifblock;
      let t = [];
      setifblock([]);

      atrim?.forEach((n, idx) => {
        if (idx !== GlobalState.ispopupdeleteClauseId) {
          t = [...t, { then: n.then, list: n.list }];
        }
      });

      setifblock(t);

      if (GlobalState.clauseCre === 1) {
        // у твоєму файлі тут збір rules для rewrite (логіку лишаю як є)
        // фактичний fetch у тебе нижче не завершений, тому не рухаю.
      } else {
        changepopupdeleteClause();
      }
    } else {
      const atrim = GlobalState.ifblock;
      let t = [];
      let l = [];
      let l0 = [];

      setifblock([]);

      atrim?.forEach((n, idx) => {
        if (idx === GlobalState.ispopupdeleteClauseId) {
          l = [];
          n.list?.forEach((y, id2) => {
            if (id2 === vid) {
              l0 = [];
              y.operator?.forEach((ty, ty2) => {
                if (ty2 !== f) l0 = [...l0, { operator: ty.operator, value: ty.value, select: ty.select }];
              });

              if (l0 && l0.length >= 1) {
                l = [...l, { title: y.title, activColumn: y.activColumn || "", type: y.type || "", operator: l0 }];
              }
            } else {
              l = [...l, { title: y.title, activColumn: y.activColumn || "", type: y.type || "", operator: y.operator || "" }];
            }
          });

          if (l.length >= 1) t = [...t, { then: n.then || "", list: l || [] }];
          else {
            l = [{ title: "if", activColumn: "", type: "", operator: [{ operator: "", value: "", select: "" }] }];
            t = [...t, { then: n.then || "", list: l || [] }];
          }
        } else {
          t = [...t, { then: n.then || "", list: n.list || [] }];
        }
      });

      setifblock(t);
    }
  };

  // ==== create/edit attribute by rules (з Sidebar) ====
  const editAttributeparam = async (u) => {
    let rules = [];
    let l = [];
    let l2 = [];

    GlobalState.ifblock?.forEach((n) => {
      l = [];
      n.list?.forEach((g) => {
        if (g.type === "categorical") {
          g.operator?.forEach((v) => {
            l2 = [];
            if (Array.isArray(v.value)) {
              v.value?.forEach((gh) => {
                if (gh.check === true) l2 = [...l2, gh.name];
              });
            }
            l = [...l, { column: g.activColumn, operator: v.operator, value: l2 }];
          });
        } else {
          g.operator?.forEach((v) => {
            l = [...l, { column: g.activColumn, operator: v.operator, value: v.value }];
          });
        }
      });
      rules = [...rules, { conditions: l, newValue: n.then }];
    });

    if (rules?.[0]?.conditions?.[0]?.column !== "") {
      const token = localStorage.getItem("token");

      const attr =
        u === 1
          ? { datasetId: activeDataset, rules, rewrite: false, newColumnName: inputNameColumn, othersValue: elseval }
          : { datasetId: activeDataset, rules, rewrite: true, newColumnName: inputNameColumn, othersValue: elseval };

      localStorage.setItem("countactivetime", Date.now());

      const allFilled = rules.every((rule) =>
        Object.values(rule).every((value) => value !== undefined && value !== null && value !== "")
      );

      if (allFilled) {
        const response = await fetch(Domen.url + `portraits/add_rule_based_attribute`, {
          method: "POST",
          headers: {
            Authorization: token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(attr),
        });

        if (response.status === 200 || response.status === 202 || response.status === "200" || response.status === "202") {
          // const data = await response.json();
          location.href = location.href;
        } else {
          alert("Something went wrong, request status:" + response.status);
        }
      }
    }
  };
  const cleanRules = (rules) => {
    const plain = toJS(rules);

    const removeThen = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(removeThen);
      }

      if (obj && typeof obj === "object") {
        const newObj = {};
        Object.keys(obj).forEach(key => {
          if (key !== "then") {
            newObj[key] = removeThen(obj[key]);
          }
        });
        return newObj;
      }

      return obj;
    };

    return removeThen(plain);
  };
  const EditAttributeNameAndParam = async (u) => {
    if (onEditAttribute) {
      onEditAttribute({
          inputNameColumn,
          activeDataset,
          elseval,
          rules: cleanRules(GlobalState.ifblock),
          segmentName,   // ✅ назва таба (актуальна)
          modelId,
          datasetType
      });
    }
  };
  
  function segmentConditionsToIfBlock(segmentConditions, columnsMeta = []) {
    const conditionsRaw =
      Array.isArray(segmentConditions)
        ? segmentConditions
        : Array.isArray(segmentConditions?.conditions)
          ? segmentConditions.conditions
          : [];

    if (conditionsRaw.length === 0) {
      return [{
        then: "",
        list: [{ title: "if", activColumn: "", type: "", operator: [{ operator: "", value: "", select: false }] }],
      }];
    }

    const getMeta = (col) => columnsMeta.find(m => m.title === col);

    const normalizeCategoryNames = (cats) => {
      if (!Array.isArray(cats)) return [];
      return cats
        .map(c => {
          if (typeof c === "string" || typeof c === "number") return String(c);
          if (c && typeof c === "object" && c.name != null) return String(c.name);
          return null;
        })
        .filter(Boolean);
    };

    const extractSelectedNames = (rawVal) => {
      // value = [{check,name}, ...]
      if (Array.isArray(rawVal)) {
        // якщо це масив об'єктів з check
        if (rawVal.some(v => v && typeof v === "object" && "check" in v)) {
          return rawVal
            .filter(v => v && typeof v === "object" && v.check === true && v.name != null)
            .map(v => String(v.name));
        }
        // якщо це масив строк/чисел
        return rawVal.map(v => (v != null ? String(v) : "")).filter(Boolean);
      }

      // value = {name, check}
      if (rawVal && typeof rawVal === "object") {
        if (rawVal.check === true && rawVal.name != null) return [String(rawVal.name)];
        if (rawVal.name != null) return [String(rawVal.name)];
        return [];
      }

      // value = string/number
      if (rawVal == null) return [];
      return [String(rawVal)];
    };

    const list = conditionsRaw.map((c, idx) => {
      const column = String(c?.column ?? "");
      const meta = getMeta(column);
      const type = meta?.type || "";

      let valueOut;

      if (type === "categorical") {
        const allNames = normalizeCategoryNames(meta?.categories);
        const selectedNames = new Set(extractSelectedNames(c?.value));
        valueOut = allNames.map(name => ({ name, check: selectedNames.has(name) }));
      } else {
        valueOut = c?.value != null ? String(c.value) : "";
      }

      return {
        title: idx === 0 ? "if" : "and",
        activColumn: column,
        type,
        operator: [{
          operator: String(c?.operator ?? ""),
          value: valueOut,
          select: false,
        }],
      };
    });

    return [{ then: "", list }];
  }
  useEffect(() => {
    if (!datasetId) {
      didInitColumnsRef.current = false;
      return;
    }

    if (didInitColumnsRef.current) return;

    didInitColumnsRef.current = true;
    setOptionmetricsforcreate(datasetId);
  }, [datasetId]);

  useEffect(() => {
    if (!initialSegmentConditions) {
      setDatasetType("");
      setElseval("");
      setInputNameColumn("");

      setifblock([
        {
          then: "",
          list: [
            {
              title: "if",
              activColumn: "",
              type: "",
              operator: [{ operator: "", value: "", select: false }],
            },
          ],
        },
      ]);

      return;
    }

    if (initialSegmentConditions.testingSegment) {
      setDatasetType(initialSegmentConditions.testingSegment);
    } else {
      setDatasetType("");
    }

    const rebuilt = segmentConditionsToIfBlock(initialSegmentConditions, activedataset);
    setifblock(rebuilt);
  }, [initialSegmentConditions, activedataset]);

  // countnowword у Sidebar був var=0
  const countnowword = 0;

  return (
    <CreateSegmentation
      langv={langv}
      errorNameAttr={errorNameAttr}
      inputNameColumn={inputNameColumn}
      DropdownIndicator={DropdownIndicator}
      optionscsw={optionscsw}
      customStyles={customStyles}
      activeDataset={activeDataset}
      setInputNameColumn0={setInputNameColumn0}
      updateselect={updateselect}
      optionif={optionif}
      customStylesoper={customStylesoper}
      setOptionmetrics1={setOptionmetrics1}
      setOptionmetricsforcreate={setOptionmetricsforcreate}
      elseval={elseval}
      optionoper={optionoper}
      setOperator={setOperator}
      setValueselect={setValueselect}
      addNewLine={addNewLine}
      addNewLinesubsub2={addNewLinesubsub2}
      addNewLinesub={addNewLinesub}
      optionopercat={optionopercat}
      blockRef={blockRef}
      textinselect={textinselect}
      countword={countword}
      countnowword={countnowword}
      setOpenselectful={setOpenselectful}
      checkmultiselectmulty={checkmultiselectmulty}
      countwordLast={countwordLast}
      setOpenselectful2={setOpenselectful2}
      changeThen={changeThen}
      setElseval={setElseval}
      changepopupdeleteClauseInside={changepopupdeleteClauseInside}
      changepopupdeleteClause={changepopupdeleteClause}
      EditAttributeNameAndParam={EditAttributeNameAndParam}
      datasetId={datasetId}
      setDatasetType={setDatasetType}
      datasetType={datasetType}
      additionOff={additionOff}
      readOnly={!!readOnly}
    />
  );
});

export default CreateSegmentationBlock;
